import React, { useContext as useContextCore } from 'react'

export type ProviderProps = {
  children: React.ReactNode
}

export type ContextType = Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const ReportsProvider = ({ children, ...props }: ProviderProps) => {
  return <CoreProvider value={{ ...props }}>{children}</CoreProvider>
}

export const useReportsContext = () => useContextCore(context)
